<template>
    <div class="lesson" v-if="configuration">
        <template v-for="(page, index) of contents">
            <div class="page">
                <resource :content="page" />
            </div>
            <div class="flex flex-center page-number">
                <div class="badge">Page {{index + 1}}</div>
            </div>
        </template>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'Lesson',
        props: {
            configuration: Object
        },
        computed: {
            contents(){
                if(!this.configuration.contents){
                    return [];
                }

                return this.configuration.contents.slice()
                .sort((a, b) => {
                    return this.configuration.data.sort.indexOf(a.data.guid) - this.configuration.data.sort.indexOf(b.data.guid);
                });
            }
        },
        methods: {
            type(widget){
                if(types.hasOwnProperty(widget.contentType)){
                    return types[widget.contentType];
                }

                return widget.contentType;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .page
    {
        max-width: 800px;
        border-radius: 6px;
        margin-top: 50px;

        img
        {
            width: 100%;
            object-fit: cover;
        }
    }

    .page-number
    {
        max-width: 800px;
        margin: 30px 0 70px;
    }

    .badge
    {
        padding: 2px 8px;
        height: 22px;
        line-height: 18px;
        border-radius: 15px;
        font-size: 12px;
        font-weight: 600;
        white-space: nowrap;
        text-transform: uppercase;
        background: fade(@base, 20%);
        color: @base;
    }
    @media print {
        .page-number {
            display: none !important;
        }
    }
</style>
